module.exports = __webpack_public_path__ + "static/media/gigs-nav.10286055.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/gigs-nav.svg
// module id = 106
// module chunks = 0